import { Component, Input } from '@angular/core';
import { FieldLabelProps } from './field-label-props';

@Component({
  selector: 'app-field-label',
  templateUrl: './field-label.component.html',
  styleUrls: ['./field-label.component.scss'],
  standalone: false
})
export class FieldLabelComponent {
  @Input() props: FieldLabelProps;
  //** Optional. Sets the label's id attribute */
  @Input() id: string;
  /** if false will use props.name as the label */
  @Input() useAttributeDescription: boolean = true;
  //** adds some styling and hides the ng-content if true */
  @Input() readonly: boolean = false;
}
